import "./BaseModal.scss";
import Close from "../../../images/close-light.svg";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import { Typography } from "@mui/material";

export default function BaseModal({
  handleClose, // function to close the modal
  open, // boolean to determine if the modal is open or not
  children, // children to be rendered in the modal
  width, // width of the modal if required otherwise it will be 50%
  baseHeight, // height of the modal if required otherwise it will be auto
  headerText, // header text of the modal
  height
}) {
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: width ? width : "50%",
    bgcolor: "background.paper",
    boxShadow: 24,
    p: 4,
    borderRadius: 6,
    minHeight: baseHeight,
    height: height
  };

  const handleOpenCustomerDetails = () => {
    handleClose();
  };

  return (
    <Box>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Box className="d-flex justify-content-between">
            <Box onClick={handleOpenCustomerDetails}>
              <Typography className="modal-header-text">{headerText}</Typography>
            </Box>
            <img className="pointer" src={Close} onClick={handleClose} loading="lazy" />
          </Box>

          {children}
        </Box>
      </Modal>
    </Box>
  );
}
